import * as types from '../actions/constants'

const INITIAL_STATE = {
    answers: new Map(),
};
export default (state = INITIAL_STATE, action) => {
    switch(action.type){
        case types.ADD_CONSULT_REQUEST_ANSWER:
            return {...state, answers: new Map([...action.payload, ...state.answers]) };
        case types.REMOVE_CONSULT_REQUEST_ANSWER:
            let newMap = new Map(state.answers);
            newMap.delete(action.payload)
            return {...state, answers: newMap };
        default:
            return state;
    }
}